import DashboardTemplate from './DashboardTemplate';
export default DashboardTemplate;
